
const columns = [
    {
        title: "تاریخ ثبت",
        dataIndex: "createdAt",
        key: "createdAt",
        width: 130,
        sorter: true,
      },
      {
        title: "زمان ثبت",
        dataIndex: "createdTime",
        key: "createdTime",
        width: 130,
      },
  {
    title:   "کاربر",
    dataIndex: "payer",
    key: "payer",
    width: 160,
    ellipsis: true
  },
  {
    title: "مبلغ (ریال)",
    dataIndex: "amount",
    key: "amount",
    width: 140,
    sorter:true
  },
  {
    title: "توضیحات",
    dataIndex: "description",
    key: "description",
    ellipsis: true
  },
];

export default columns;
